import React from 'react';
import {
  InputAccessoryView,
  Keyboard,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
} from 'react-native';

import { colors, spacing, typography } from '../../core/theme/tokens';
import { KEYBOARD_DONE_ACCESSORY_ID } from './keyboard';

/** iOS toolbar so number / decimal / phone pads can be dismissed. */
export function KeyboardDoneAccessory() {
  if (Platform.OS !== 'ios') return null;

  return (
    <InputAccessoryView
      nativeID={KEYBOARD_DONE_ACCESSORY_ID}
      backgroundColor={colors.surfaceElevated}
    >
      <View style={styles.bar}>
        <Pressable
          onPress={() => Keyboard.dismiss()}
          accessibilityRole="button"
          accessibilityLabel="Dismiss keyboard"
          hitSlop={8}
          style={({ pressed }) => [styles.done, pressed && styles.pressed]}
        >
          <Text style={styles.doneText}>Done</Text>
        </Pressable>
      </View>
    </InputAccessoryView>
  );
}

const styles = StyleSheet.create({
  bar: {
    minHeight: 44,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingHorizontal: spacing.md,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: colors.glassBorder,
    backgroundColor: colors.surfaceElevated,
  },
  done: {
    minHeight: 44,
    justifyContent: 'center',
    paddingHorizontal: spacing.xs,
  },
  doneText: {
    ...typography.body,
    fontWeight: '700',
    color: colors.accent,
  },
  pressed: {
    opacity: 0.7,
  },
});
